import { Checkbox } from "@primer/react";

export const notificationsTableConfig = () => {
    return [
        {
            id: "select",
            field: "",
            sortBy: "basic",
            header: () => <Checkbox value="default" disabled />,
            rowHeader: true,
            maxWidth: 40
        },
        {
            id: "name",
            header: "Заголовок",
            field: "name",
            sortBy: "basic",
        },
        {
            id: "body",
            header: "Тело",
            field: "body",
        },
        {
            id: "status",
            header: "Статус и время",
            field: "status",
        },
        {
            id: "langs",
            header: "Языки",
            field: "langs",
        },
        {
            id: "actions",
            header: "",
            field: "address",
        },
    ];
}
